export default function RandomImage(id) {
    return `/images/banner/${id % 10}.jpg`;
}